export const getTaskDisplayName = (task) => {
  if (task?.regular_task_key === "agreement" && task?.agreement_year) {
    return `${task.nama} Tahun ${task.agreement_year}`;
  }
  return task?.nama || "";
};